// extracted by mini-css-extract-plugin
export default {"date-number__text":"styles_date-number__text__fRoik","day-name__text":"styles_day-name__text__EtIV6"};